<template>
  <v-container class="py-5" style="max-width: 90vw">
    <v-row>
      <v-col cols="9">
        <div style="display: flex" class="justify-space-between align-center">
          <div>
            <TitleComponent title="Tambah Aset" />
            <breadcrumbs-component :crumbs="crumbs" />
          </div>
        </div>
        <div class="mt-10">
          <div>
            <v-container
              style="border-radius: 20px; border: 1px #abd1c6 solid"
              class="px-7 py-7"
            >
              <v-row>
                <template v-for="property in properties">
                  <v-col cols="12" md="6" :key="property.key">
                    <card-detail-component
                      :label="property.label"
                      :value="asset[property.key]"
                      :editable="isEditable"
                      v-model="asset[property.key]"
                      :placeholder="property.placeholder"
                      :rules="property.rules"
                      :max-length="property.maxLength"
                    />
                  </v-col>
                </template>
                <!-- Umur Manfaat -->
                <v-col cols="12" md="6">
                  <div
                    style="
                      box-shadow: 0px 2px 10px rgba(232, 228, 230, 0.7);
                      border-radius: 15px;
                    "
                  >
                    <div
                      style="
                        background: #bee3d9;
                        border-top-left-radius: 15px;
                        border-top-right-radius: 15px;
                      "
                      class="d-flex align-center"
                    >
                      <h3
                        style="
                          font-size: 16px;
                          font-weight: 700;
                          word-wrap: break-word;
                        "
                        class="px-3 py-2"
                      >
                        Umur Manfaat
                      </h3>
                    </div>
                    <v-row class="px-3 py-2">
                      <v-row>
                        <v-col cols="6">
                          <div class="d-flex align-center">
                            <v-select
                              class="px-3 py-2"
                              placeholder="Pilih Tahun"
                              v-model="asset.useful_life_year"
                              :items="Array.from({ length: 100 }, (_, i) => i)"
                              dense
                            ></v-select>
                            <span class="mx-2">Tahun</span>
                          </div>
                        </v-col>
                        <v-col cols="6">
                          <div class="d-flex align-center">
                            <v-select
                              class="px-3 py-2"
                              placeholder="Pilih Bulan"
                              v-model="asset.useful_life_month"
                              :items="Array.from({ length: 12 }, (_, i) => i)"
                              dense
                            ></v-select>
                            <span class="mx-2">Bulan</span>
                          </div>
                        </v-col>
                      </v-row>
                    </v-row>
                  </div>
                </v-col>
                <!-- Upload Image -->
                <v-col cols="12" md="6">
                  <div
                    style="
                      box-shadow: 0px 2px 10px rgba(232, 228, 230, 0.7);
                      border-radius: 15px;
                    "
                  >
                    <div
                      style="
                        background: #bee3d9;
                        border-top-left-radius: 15px;
                        border-top-right-radius: 15px;
                      "
                      class="d-flex align-center"
                    >
                      <h3
                        style="
                          font-size: 16px;
                          font-weight: 700;
                          word-wrap: break-word;
                        "
                        class="px-3 py-2"
                      >
                        Foto Aset
                      </h3>
                    </div>
                    <div>
                      <div class="mx-3 my-2 py-2">
                        <label id="label-image" for="file-upload">+</label>
                        <input
                          type="file"
                          id="file-upload"
                          multiple
                          @change="handleFileUpload"
                          accept="image/*"
                        />
                        <div class="image-container">
                          <div
                            v-for="(image, index) in images"
                            :key="index"
                            class="image-item"
                          >
                            <img
                              :src="image.previewUrl"
                              alt="Preview"
                              class="pic"
                              @click="showImage(index)"
                            />
                            <button
                              class="remove-button"
                              @click="removeImage(index)"
                            >
                              X
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-col>
                <template v-for="(item, index) in customItems">
                  <v-col cols="12" md="6" :key="index">
                    <card-detail-component
                      :label="item.information_name"
                      :value="item.information_value"
                      :editable="isEditable"
                      v-model="item.information_value"
                      :isCustom="true"
                      @closeCard="removeCustomItem(index, item.id)"
                    />
                  </v-col>
                </template>
                <v-col cols="12" md="6">
                  <v-dialog v-model="dialog" max-width="434px">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="mx-2"
                        v-bind="attrs"
                        v-on="on"
                        fab
                        small
                        @click="addCard"
                      >
                        <v-icon dark> mdi-plus</v-icon>
                      </v-btn>
                    </template>
                    <v-card>
                      <v-form ref="form" v-model="valid">
                        <v-card-title class="mb-5">
                          Tambah Keterangan
                          <v-spacer></v-spacer>
                          <v-btn icon @click="dialog = false">
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </v-card-title>
                        <v-card-text>
                          <h4>Nama Keterangan</h4>
                          <v-text-field
                            class="py-0"
                            required
                            v-model="newCard.label"
                            :rules="[
                              !!newCard.label ||
                                'Nama Keterangan tidak boleh kosong',
                            ]"
                          ></v-text-field>
                          <h4>Isi Keterangan</h4>
                          <v-text-field
                            class="py-0"
                            required
                            v-model="newCard.value"
                            :rules="[
                              !!newCard.value ||
                                'Isi Keterangan tidak boleh kosong',
                            ]"
                          >
                          </v-text-field>
                          <div class="text-center mt-auto">
                            <v-btn
                              class="white--text text-capitalize"
                              color="#004643"
                              width="80%"
                              @click="submitForm"
                              >Simpan
                            </v-btn>
                          </div>
                        </v-card-text>
                      </v-form>
                    </v-card>
                  </v-dialog>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-btn
                  @click="submitAset()"
                  class="white--text text-capitalize ml-2"
                  color="#004643"
                  >Simpan
                </v-btn>
              </v-row>
            </v-container>
          </div>
          <div></div>
        </div>
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbar" :timeout="timeout" shaped top color="white">
      {{ message }}
      <template v-slot:action="{ attrs }">
        <v-btn color="#004643" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <v-dialog v-model="dialogLoading" hide-overlay persistent width="300">
      <v-card>
        <v-card-text>
          Mohon tunggu
          <v-progress-linear
            indeterminate
            color="green"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import TitleComponent from "@/components/TitleComponent";
import BreadcrumbsComponent from "@/components/BreadcrumbsComponent.vue";
import CardDetailComponent from "@/components/CardDetailComponent";

export default {
  components: {
    TitleComponent,
    CardDetailComponent,
    BreadcrumbsComponent,
  },
  methods: {
    doSelectAndShowPopUpMenu(data) {
      this.optionDialog = true;
      this.filterChoices = data.title;
    },
    editAset() {
      this.isEditable = true;
    },
    addCard() {
      if (this.newCard.label && this.newCard.value) {
        this.customItems.push({
          information_name: this.newCard.label,
          information_value: this.newCard.value,
          asset_id: this.$route.params.id,
        });

        this.newCard.label = "";
        this.newCard.value = "";
      }
      console.log(this.customItems);
    },
    closeDialog() {
      this.dialog = false;
    },
    submitForm() {
      this.$refs.form.validate();
      if (this.valid) {
        this.addCard();
        this.closeDialog();
      }
    },
    removeCustomItem(index, id) {
      this.customItems.splice(index, 1);
      if (id) {
        this.$axios
          .delete(`/additional-information/${id}`)
          .then(() => {})
          .catch((err) => {
            console.log(err);
          });
      }
    },
    async submitAset() {
      this.dialogLoading = true;
      const imageUrls = [];
      for (let i = 0; i < this.images.length; i++) {
        const formData = new FormData();
        formData.append("image", this.images[i].file);
        const response = await this.$axios.post("/upload-image", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        imageUrls.push(response.data.url);
      }
      this.asset.useful_life_months =
        this.asset.useful_life_year * 12 + this.asset.useful_life_month;

      await this.$axios
        .post(`/assets`, {
          data: {
            ...this.asset,
            imageUrls,
            date_of_acquisition: (() => {
              if (!this.asset.date_of_acquisition) return null;
              const [month, year] = this.asset.date_of_acquisition.split("-");
              if (!month || !year) return this.asset.date_of_acquisition;
              return `${year}-${month.padStart(2, "0")}-01`;
            })(),
          },
          additionalData: this.customItems,
        })
        .then((response) => {
          this.message = response.data.message;
          this.snackbar = true;
          this.dialogLoading = false;

          if (response.data.success) {
            new Promise((resolve) => setTimeout(resolve, 2000)).then(() =>
              this.$router.push("/aset")
            );
          }
        });
    },
    handleFileUpload(event) {
      const files = event.target.files;
      for (let i = 0; i < files.length; i++) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.images.push({
            file: files[i],
            previewUrl: e.target.result,
          });
        };
        reader.readAsDataURL(files[i]);
      }
    },
    removeImage(index) {
      this.images.splice(index, 1);
    },
  },
  data: () => ({
    dialogLoading: false,
    selectedImage: null,
    snackbar: false,
    message: "",
    timeout: 3000,
    filterChoices: "",
    optionDialog: false,
    date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    information: "",
    properties: [
      {
        label: "Kategori Utama",
        key: "asset_category",
        placeholder: "Pilih Kategori Utama",
        rules: [(v) => !!v || "Kategori Utama tidak boleh kosong"],
      },
      {
        label: "Kode Registrasi",
        key: "asset_code",
        placeholder: "Tulis Keterangan",
        rules: [
          (v) => !!v || "Kode Registrasi tidak boleh kosong",
          (v) => {
            if (!v) return true;
            const value = v.replace(/\s/g, "");
            const parts = value.split("/");
            if (parts.length !== 2)
              return "Format harus mengandung '/' sebagai pemisah";
            const left = parts[0].replace(/\./g, "");
            const right = parts[1].replace(/\./g, "");
            if (left.length < 18)
              return "18 digit pertama (sebelum '/') tidak valid";
            if (right.length < 16)
              return "Kode Barang dan Nomor Urut Barang tidak valid";
            const kodeLokasi = left.slice(0, 18);
            const kodeBarang = right.slice(0, 10);
            const nomorUrut = right.slice(-6);
            if (!/^\d{18}$/.test(kodeLokasi))
              return "Kode Lokasi harus 18 digit angka";
            if (!/^\d{10}$/.test(kodeBarang))
              return "Kode Barang harus 10 digit angka";
            if (!/^\d{6}$/.test(nomorUrut))
              return "Nomor Urut Barang harus 6 digit angka";
            return true;
          },
        ],
      },
      {
        label: "Nama Barang",
        key: "asset_name",
        placeholder: "Masukkan Nama Aset",
        rules: [(v) => !!v || "This field is required"],
      },
      {
        label: "Seksi",
        key: "section",
        placeholder: "Masukkan Seksi Aset",
        rules: [(v) => !!v || "Seksi tidak boleh kosong"],
      },
      {
        label: "Golongan",
        key: "asset_group",
        placeholder: "Masukkan Golongan Aset",
        rules: [(v) => !!v || "Golongan tidak boleh kosong"],
      },
      {
        label: "Bidang",
        key: "asset_field",
        placeholder: "Masukkan Bidang Aset",
        rules: [(v) => !!v || "Bidang tidak boleh kosong"],
      },
      {
        label: "Kelompok",
        key: "asset_classification",
        placeholder: "Masukkan Kelompok Aset",
        rules: [(v) => !!v || "Kelompok tidak boleh kosong"],
      },
      {
        label: "Sub Kelompok",
        key: "asset_sub_classification",
        placeholder: "Masukkan Sub Kelompok Aset",
        rules: [(v) => !!v || "Sub Kelompok tidak boleh kosong"],
      },
      {
        label: "Sub Sub Kelompok",
        key: "asset_sub_sub_classification",
        placeholder: "Masukkan Sub Sub Kelompok Aset",
        rules: [(v) => !!v || "Sub Sub Kelompok tidak boleh kosong"],
      },
      {
        label: "Lokasi",
        key: "asset_location",
        placeholder: "Masukkan Lokasi",
        rules: [(v) => !!v || "Lokasi tidak boleh kosong"],
      },
      {
        label: "X Awal",
        key: "x_start",
        placeholder: "Masukkan Koordinat X Awal",
        rules: [(v) => !!v || "Koordinat X Awal tidak boleh kosong"],
      },
      {
        label: "X Akhir",
        key: "x_end",
        placeholder: "Masukkan Koordinat X Akhir",
        rules: [(v) => !!v || "Koordinat X Akhir tidak boleh kosong"],
      },
      {
        label: "Y Awal",
        key: "y_start",
        placeholder: "Masukkan Koordinat Y Awal",
        rules: [(v) => !!v || "Koordinat Y Awal tidak boleh kosong"],
      },
      {
        label: "Y Akhir",
        key: "y_end",
        placeholder: "Masukkan Koordinat Y Akhir",
        rules: [(v) => !!v || "Koordinat Y Akhir tidak boleh kosong"],
      },
      {
        label: "Sumber Dana",
        key: "funding_source",
        placeholder: "Masukkan Sumber Dana Aset",
        rules: [(v) => !!v || "Sumber Dana tidak boleh kosong"],
      },
      {
        label: "Nilai Perolehan",
        key: "price_of_acquisition",
        placeholder: "Masukkan Nilai Perolehan Aset",
        rules: [
          (v) => !!v || "Nilai Perolehan tidak boleh kosong",
          (v) => !isNaN(v) || "Nilai Perolehan harus berupa angka",
        ],
      },
      {
        label: "Tahun Perolehan",
        key: "date_of_acquisition",
        placeholder: "Pilih Tanggal Perolehan",
        rules: [(v) => !!v || "Tanggal Perolehan tidak boleh kosong"],
      },
      {
        label: "Keterangan",
        key: "information",
        placeholder: "Masukkan Keterangan Tambahan (Opsional)",
        rules: [],
      },
      {
        label: "Pemilik",
        key: "asset_owner",
        placeholder: "Masukkan Pemilik Aset",
        rules: [(v) => !!v || "Pemilik Aset tidak boleh kosong"],
      },
      {
        label: "Pengembang",
        key: "asset_developer",
        placeholder: "Masukkan Pengembang Aset",
        rules: [(v) => !!v || "Pengembang Aset tidak boleh kosong"],
      },
      {
        label: "Pengelola",
        key: "asset_operator",
        placeholder: "Masukkan Operator Aset",
        rules: [(v) => !!v || "Pengelola Aset tidak boleh kosong"],
      },
    ],
    valid: true,
    isEditable: true,
    newCard: {
      label: "",
      value: "",
    },
    customItems: [],
    dialog: false,
    asset: {
      asset_category: null,
      asset_code: null,
      asset_name: null,
      section: null,
      asset_location: null,
      asset_group: null,
      asset_field: null,
      asset_classification: null,
      asset_sub_classification: null,
      asset_sub_sub_classification: null,
      x_start: null,
      x_end: null,
      y_start: null,
      y_end: null,
      funding_source: null,
      date_of_acquisition: null,
      information: null,
      asset_owner: null,
      asset_developer: null,
      asset_operator: null,
      useful_life_year: 0,
      useful_life_month: 0,
      price_of_acquisition: null,
    },
    images: [],
    menu: false,
  }),
  computed: {
    crumbs() {
      return [
        {
          text: "Layanan Aset",
          disabled: false,
          href: "/aset",
        },
        {
          text: "Tambahkan Aset",
          disabled: true,
          href: "/aset/create",
        },
      ];
    },
  },
};
</script>

<style>
input[type="file"] {
  display: none;
}

#label-image {
  padding: 10px 16px;
  color: #004643;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  border-radius: 50%;
  transition: background-color 0.3s ease;
  border: 1px solid #004643;
}

#label-image:hover {
  background-color: #004643;
  color: #ffffff;
}

.image-container {
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
}

.image-item {
  position: relative;
  margin-right: 10px;
  margin-bottom: 10px;
}

.pic {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 10px;
  cursor: pointer;
}

.remove-button {
  position: absolute;
  top: 5px;
  right: 5px;
  padding: 3.5px 10px;
  background-color: #f44336;
  color: white;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  font-weight: bold;
}

.remove-button:hover {
  background-color: #d32f2f;
}
</style>
